export default __webpack_public_path__ + "assets/ghanem-component.16344b23.svg";